<template>
  <div>
    <!-- Kesihatan Persekitaran Menu -->
    <div
      class="kesihatan-persekitaran-menu"
      :class="{ open: isKesihatanPersekitaranMenuOpen }"
    >
      <ul>
        <li>
          <RouterLink to="/kesihatan-persekitaran">
            Permis Makanan
          </RouterLink>
        </li>        
        <li>
          <RouterLink to="/kesihatan-persekitaran/pasar-awam-pbt">
            Pasar Awam PBT
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/kesihatan-persekitaran/haiwan-terbiar">
            Haiwan Terbiar
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/kesihatan-persekitaran/cegah-jangkit">
            Cegah Jangkit
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/kesihatan-persekitaran/vektor">
            Vektor
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/kesihatan-persekitaran/kempen">
            Kempen
          </RouterLink>
        </li>
      </ul>
    </div>
    <div
      v-if="isKesihatanPersekitaranMenuOpen"
      class="overlay"
      @click="closeMenus"
    />
    <button
      v-if="!isKesihatanPersekitaranMenuOpen"
      class="kesihatan-persekitaran-toggle-button"
      @click="toggleKesihatanPersekitaranMenu"
    >
      <span class="vertical-text">KESIHATAN PERSEKITARAN</span>
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const isKesihatanPersekitaranMenuOpen = ref(false)

const toggleKesihatanPersekitaranMenu = () => {
  isKesihatanPersekitaranMenuOpen.value = !isKesihatanPersekitaranMenuOpen.value
  if (isKesihatanPersekitaranMenuOpen.value) {
    closeMainMenu()
  }
}

const closeMenus = () => {
  isKesihatanPersekitaranMenuOpen.value = false
  closeMainMenu()
}

const closeMainMenu = () => {
  // Emit event to close Main Menu
  const event = new CustomEvent('close-main-menu')

  window.dispatchEvent(event)
}

window.addEventListener('close-kesihatan-persekitaran-menu', () => {
  isKesihatanPersekitaranMenuOpen.value = false
})
</script>

<style scoped>
/* Kesihatan Persekitaran Menu */
.kesihatan-persekitaran-menu {
  position: fixed;
  top: 30%;
  right: 0;
  width: 200px;
  height: auto;
  max-height: 70%;
  background-color: #312867;
  color: white;
  padding: 10px 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s;
  transform: translateX(100%);
  z-index: 1000;
  border-radius: 10px;
}

.kesihatan-persekitaran-menu.open {
  transform: translateX(0);
}

.kesihatan-persekitaran-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.kesihatan-persekitaran-menu li {
  margin-bottom: 10px;
}

.kesihatan-persekitaran-menu a,
.kesihatan-persekitaran-menu router-link {
  color: white;
  text-decoration: none;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Kesihatan Persekitaran Toggle Button */
.kesihatan-persekitaran-toggle-button {
  position: fixed;
  top: 40%;
  right: -10px;
  transform: translateY(-50%);
  background-color: #312867;
  border: none;
  padding: 2px;
  border-radius: 5px 0 0 5px;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 100;
  transition: right 0.3s;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.kesihatan-persekitaran-toggle-button .vertical-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

.menu-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
